import { ThemeUIStyleObject } from "theme-ui"

export const BackgroundImageStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden",
}
export const ImageStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
}

export const ContentWrapperStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: "0",
  width: "100%",
  height: "100%",
  zIndex: "2",
  overflow: "hidden",
}
